import AccordionItems from "@/components/molecules/AccordionItems";
import Hero from "@/components/organisms/Hero";
import Title from "@/components/atoms/Title";
const FaqsSection = ({ data, title = "", text = "" }) => {
  return (
    <section className="base-container base-grid py-16">
      <Hero
        title={{
          text: title || "",
          tag: "h1",
          className: "hero-title text-3xl md:text-5xl",
        }}
        text={{
          text: text,
          className: "section-subtitle text-center uppercase text-[14px] lg:text-[16px]",
        }}
        styles={{
          heroContainer:
            "col-span-12 lg:col-span-10 lg:col-start-2 mb-6 md:mb-12",
          textContainer: "col-span-12 md:col-start-2 md:col-span-10 order-0",
          titleContainer: "col-span-12 md:col-start-2 md:col-span-10 order-1",
        }}
      />
      <div className="col-span-12 lg:col-span-10 lg:col-start-2">
        {data?.map((item, key) => {
          return <AccordionItems key={key} item={item} />;
        })}
      </div>
    </section>
  );
};
export default FaqsSection;
